// ** Styled Components
import { FormMessageStyled } from './styles'

interface IProps {
	/**
	 * Text color
	 */
	color?: 'primary' | 'secondary' | 'success' | 'error' | 'warning' | 'text'
	/**
	 * Text content
	 */
	children: React.ReactNode
	/**
	 * Always show to prevent layout shifts
	 */
	alwaysShow?: boolean
}

export const FormHelperText = ({ color = 'text', children, alwaysShow = false }: IProps) => {
	if (alwaysShow) {
		// Always render but make invisible when no children
		return (
			<FormMessageStyled 
				color={color} 
				style={{ visibility: children ? 'visible' : 'hidden' }}
			>
				{children || '\u00A0'} {/* Non-breaking space when no content */}
			</FormMessageStyled>
		)
	}
	
	return <FormMessageStyled color={color}>{children}</FormMessageStyled>
}
